/**
 * Language Toggle — switches between EN and TH instantly.
 * Renders as a compact pill with the two language codes.
 */

import React from "react";
import { useTranslation } from "react-i18next";

export const LanguageToggle: React.FC = () => {
  const { i18n, t } = useTranslation();
  const current = i18n.language;

  const switchTo = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="inline-flex items-center rounded-full border border-neutral-200 bg-white overflow-hidden" role="group" aria-label={t("common.languageSelector")}>
      <button
        onClick={() => switchTo("en")}
        className={`px-2.5 py-1 text-xs font-semibold transition-colors ${
          current === "en"
            ? "bg-ink-950 text-primary-500"
            // 6.05:1 on the bg-white pill. neutral-500 was 2.64:1 — measured
            // in the browser, on a control whose two halves are the only way
            // to change the app's language.
            : "text-neutral-700 hover:bg-neutral-50"
        }`}
        aria-pressed={current === "en"}
      >
        EN
      </button>
      <button
        onClick={() => switchTo("th")}
        className={`px-2.5 py-1 text-xs font-semibold transition-colors ${
          current === "th"
            ? "bg-ink-950 text-primary-500"
            // 6.05:1 on the bg-white pill. neutral-500 was 2.64:1 — measured
            // in the browser, on a control whose two halves are the only way
            // to change the app's language.
            : "text-neutral-700 hover:bg-neutral-50"
        }`}
        aria-pressed={current === "th"}
      >
        TH
      </button>
    </div>
  );
};

export default LanguageToggle;
